import { render, staticRenderFns } from "./Snowboard.vue?vue&type=template&id=51b72dc6"
import script from "./Snowboard.vue?vue&type=script&lang=js"
export * from "./Snowboard.vue?vue&type=script&lang=js"
import style0 from "./Snowboard.vue?vue&type=style&index=0&id=51b72dc6&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports